// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import CustomerRefusalDetails from './customer-refusal-details';
import NoResponseDetails from './no-response-details';
import PipCode from '@deere/cps-it.warranty-model-factory/lib/pip-code';

const PipCodeTypeDetails = props => {

    const pipCodeType = props.pipCode.pipCodeType.key;

    return (
        <div className='pip-code-fields-wrapper'>
            {pipCodeType === '01' ?
                <CustomerRefusalDetails
                    onItemChange={props.onItemChange}
                    pipCode={props.pipCode}
                /> :
            null}
            {pipCodeType === '02' ?
                <NoResponseDetails
                    onItemChange={props.onItemChange}
                    pipCode={props.pipCode}
                /> :
            null}
        </div>
    );

};

PipCodeTypeDetails.displayName = 'PipCodeTypeDetails';
PipCodeTypeDetails.propTypes = {
    onItemChange: PropTypes.func.isRequired,
    pipCode: PropTypes.instanceOf(PipCode).isRequired
};

export default PipCodeTypeDetails;



// WEBPACK FOOTER //
// ./src/pip/pip-code/components/pip-code-type-details.js